/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner } from './get-card-transactions200-response-merged-transaction-detail-list-inner-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];


